import { render, staticRenderFns } from "./shyk.vue?vue&type=template&id=7889a11b&scoped=true&"
import script from "./shyk.vue?vue&type=script&lang=js&"
export * from "./shyk.vue?vue&type=script&lang=js&"
import style0 from "./shyk.vue?vue&type=style&index=0&id=7889a11b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889a11b",
  null
  
)

export default component.exports